import React, {Component} from 'react';
import { reviseTUser, adminloadTP, AuthenticatedUser, putToast, stopTimer } from "../../../api";
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import TournamentPageTemplate from '../tournamentPageTemplate'

class TournamentAdminAssignments extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.getTdProps = this.getTdProps.bind(this);
        this.onAdminUpdate = this.onAdminUpdate.bind(this);


        this.state = {
            loading: true,
            open: false,
            user: user,
            tData: {},
            assignments: [],
            pid: params.pid,
        }

    }

    loadTournamentPage = () => {       
        if (this.state.pid) {
            adminloadTP('none', 'zulu', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    const data = this.buildData(d2.tournamentPage, d2.tUsers);
                    this.setState({tData: d2.tournamentPage, tUsers: d2.tUsers, assignments: data, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
        }
    }

    getTdProps(rowInfo, column) {
        if (rowInfo && rowInfo.row) {
            if (column.id !== "override" && column.id !== "assigned") {
                return {
                    onClick: () => { 
                        //const roomId = rowInfo.original.roomId;
                        //const judgeId = rowInfo.original.judge.userId;
                        //this.props.history.push(`/tournament/ballot/room/judge/${this.state.tData._id}/${roomId}/${judgeId}`)
                    },
                    onMouseOver: (e) => {
                        this.setState({
                            selected: rowInfo.index
                        })
                    },
                    style: {
                        background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                        //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                }
            } else { 
                return {
                    style: {
                        background: rowInfo.index === this.state.selected ? '#d3dacf' : 'white',
                        //color: rowInfo.index === this.state.selected ? 'white' : 'black'
                    }
                }
            }
        } else {
            return {}
        }
    }

    
    onAdminUpdate(evt, check, assignment) {
        const {tUsers, assignments} = this.state;
        
        const val = evt.target.checked;

        if (assignment) {
            if (check === "iso") {
                assignment.isAdminOverride = val;
                if (!val) { 
                    assignment.isAdminAssigned = val; // if !override, then can't be assigned
                    const cb = document.getElementById(`isa${assignment.userId}`);
                    cb.checked = val;
                }
            }
            if (check === "isa") {
                assignment.isAdminAssigned = val;
                if (val) { 
                    assignment.isAdminOverride = val; // if assigned, also overridden
                    const cb = document.getElementById(`iso${assignment.userId}`);
                    cb.checked = val;
                }
            }
        }

        const tUser = tUsers.find(x=>x.userId === assignment.userId);
        const turEvent = tUser.rounds.find(x=>x.roundId === assignment.roundId).events.find(y=>y.eventId === assignment.eventId);
        if (turEvent) {
            turEvent.isAdminAssigned = assignment.isAdminAssigned;
            turEvent.isAdminOverride = assignment.isAdminOverride;

            reviseTUser(tUser).then(d2 => {
                if (!d2 || d2.error) {
                    console.log(d2 ? d2.error : "Error - no data");
                    putToast.error(d2 ? d2.error : "Error - no data");
                } else {
                    putToast.success(d2.message);
                }
            });    
        }
        this.setState({assignments})
    }
    
    buildData(tp, tUsers) {
        const data = [];
        for(const tUser of tUsers.filter(x=>x.isJudge)) {
            for(const tuRound of tUser.rounds) {
                const tRound = tp.rounds.find(x=>x._id === tuRound.roundId);

                for(const turEvent of tuRound.events) {
                    const tEvent = tp.events.find(x=>x._id === turEvent.eventId);
                    const judgeRoundEventAvail = tuRound.events.find(x=> x.isAvailable);

                    data.push({
                        roundId: tRound._id,
                        round: tRound.title,
                        eventId: tEvent._id,
                        event: tEvent.title,
                        userId: tUser.userId,
                        judge: {displayname: tUser.displayname, phone: tUser.phone},
                        isAdminOverride: turEvent.isAdminOverride,
                        isAdminAssigned: turEvent.isAdminAssigned,
                        isAvailable: turEvent.isAvailable || (tuRound.isAvailable && !judgeRoundEventAvail),
                    })
                }
            }
        }
        return data;
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { tData, user, assignments } = this.state;
            
            return (
                <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Judge Assignment List - ${user.displayname}`} title3=""
                bcTitle="Judge Assignment List" bcParents={[
                    {name: tData.title, url: `/pages/tournament/${tData._id}`},
                    {name: "Administration", url: `/tournament/admin/${tData._id}`}
                ]}
                >              
                <div className="container-fluid">           
                    <div className="row">
                        <div className="col-sm-12">
                            <ReactTable
                                    filterable
                                    defaultFilterMethod={ (filter, row, column) => {
                                        const id = filter.pivotId || filter.id
                                        return row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true
                                    }}
                                data={assignments}
                                columns={[{
                                    Header: 'Override',
                                    id: 'override',
                                    accessor: 'isAdminOverride',
                                    style: { textAlign: 'center'},
                                    headerStyle: { textAlign: 'center', fontSize: "18px"}, 
                                    maxWidth: 100,                                   
                                    Cell: (row) => {
                                     return (
                                        <input
                                            type='checkbox'
                                            id={'iso'+row.original.userId}
                                            checked={row.original.isAdminOverride}
                                            onChange={(evt) => this.onAdminUpdate(evt, 'iso', row.original)}
                                            style={{zoom: "1.2", width: "20px", height: "20px"}}
                                        />                                                                                   
                                     )}
                                },{
                                    Header: 'Assigned',
                                    id: 'assigned',
                                    accessor: 'isAdminAssigned',
                                    style: { textAlign: 'center'},
                                    headerStyle: { textAlign: 'center', fontSize: "18px"}, 
                                    maxWidth: 120,                                   
                                    Cell: (row) => {
                                     return (
                                        <input
                                            type='checkbox'
                                            id={'isa'+row.original.userId}
                                            checked={row.original.isAdminAssigned}
                                            onChange={(evt) => this.onAdminUpdate(evt, 'isa', row.original)}
                                            style={{zoom: "1.2", width: "20px", height: "20px"}}
                                        />                                          
                                     )}
                                },{
                                    Header: 'Available',
                                    id: 'available',
                                    accessor: 'isAvailable',
                                    style: { textAlign: 'center'},
                                    headerStyle: { textAlign: 'center', fontSize: "18px"}, 
                                    maxWidth: 100,                                   
                                    Cell: (row) => {
                                     return (
                                        <input
                                            type='checkbox'
                                            id={'isav'+row.original.userId}
                                            checked={row.original.isAvailable}
                                            readOnly={true}
                                            style={{zoom: "1.2", width: "20px", height: "20px"}}
                                        />                                                                                   
                                     )}
                                },{
                                    Header: 'Round',
                                    accessor: 'round',
                                },{
                                    Header: 'Event',
                                    accessor: 'event',
                                },{
                                    Header: 'Judge',
                                    accessor: 'judge.displayname',
                                },{
                                    Header: 'Phone',
                                    accessor: 'judge.phone',
                                }]}                                        
                                defaultPageSize={32}
                                showPagination={true}  
                                getTdProps={this.getTdProps}                                                                                                     
                            />
                        </div>
                    </div>  
                </div>
                          
                </TournamentPageTemplate>
            )
        }
    }
}

export default TournamentAdminAssignments;